import { createStore } from "vuex"
import product from "./modules/product";
import Chat from "./modules/Chat";
import Toasts from "./modules/Toasts";
import Orders from "./modules/Orders";
import WhatsappShare from "./modules/WhatsappShare";

const store = createStore({
  modules: {
    Chat,
    product,
    Toasts,
    Orders,
    WhatsappShare
  }
});

export default store
